module.exports = __webpack_public_path__ + "static/media/OneLevelUp.158b211f.svg";